module.exports = __webpack_public_path__ + "img/icon_evaluaciones.6029030e.svg";